import config from '../config';
import apiClient from './apiClient';

const getAllCharities = async() => {
  const result = await apiClient.get(
    `${config.API_BASE_URL}/charities/get/landing-all`,
  );
  return result.data;
}

export {getAllCharities};
